import React, { useState } from "react";
import "./AdminModal.css";
import CalendarSelector from "./Components/CalendarSelector";
import "./Components/CalendarSelector.css";

function AdminModal({ isOpen, onClose, staff, onDeleteBooking, onAddBooking }) {
  const [selectedDate, setSelectedDate] = useState(null);
  const [view, setView] = useState("booked"); // "booked" o "slots"
  // Stato temporaneo per orari disponibili per giorno
  const [availableTimes, setAvailableTimes] = useState({}); // { '2025-09-30': ['09:00', '10:30'] }
  const [newTime, setNewTime] = useState("");

  if (!isOpen) return null;

  return (
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal-content" onClick={e => e.stopPropagation()}>
        <h2>{staff.name} - {staff.role}</h2>

        {/* Toggle view */}
        <div className="modal-tabs">
          <button
            className={`tab-btn ${view === "booked" ? "active" : ""}`}
            onClick={() => setView("booked")}
          >
            Appuntamenti
          </button>
          <button
            className={`tab-btn ${view === "slots" ? "active" : ""}`}
            onClick={() => setView("slots")}
          >
            Slot Liberi
          </button>
        </div>

        {/* Sezione Appuntamenti */}
        {view === "booked" && (
          <>
            {staff.bookings.length === 0 ? (
              <p>Nessuna prenotazione al momento.</p>
            ) : (
              <table className="booking-table">
                <thead>
                  <tr>
                    <th>Cliente</th>
                    <th>Data</th>
                    <th>Azione</th>
                  </tr>
                </thead>
                <tbody>
                  {staff.bookings.map(b => (
                    <tr key={b.id}>
                      <td>{b.name}</td>
                      <td>{b.date}</td>
                      <td>
                        <button
                          className="btn secondary-btn"
                          onClick={() => onDeleteBooking(staff.id, b.id)}
                        >
                          Elimina
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}

        {/* Sezione Slot liberi */}
        {view === "slots" && (
          <div>
            <CalendarSelector
              value={selectedDate}
              onChange={date => setSelectedDate(date)}
            />
            {selectedDate && (
              <>
                <div className="new-date-form">
                  <span style={{alignSelf: 'center'}}>
                    Giorno selezionato: {selectedDate.toLocaleDateString('it-IT')}
                  </span>
                </div>
                {/* Lista orari disponibili per il giorno selezionato */}
                <div style={{marginBottom: 10}}>
                  <strong>Orari disponibili:</strong>
                  <div style={{marginTop: 5, marginBottom: 5}}>
                    {(availableTimes[selectedDate.toISOString().split('T')[0]] || []).length === 0 ? (
                      <span style={{color:'#aaa'}}>Nessun orario inserito</span>
                    ) : (
                      <ul style={{display:'inline-block', paddingLeft: 0}}>
                        {availableTimes[selectedDate.toISOString().split('T')[0]].map((t, idx) => (
                          <li key={t+idx} style={{display:'flex',alignItems:'center',gap:6}}>
                            <span>{t}</span>
                            <button
                              className="btn secondary-btn"
                              style={{padding:'2px 8px',fontSize:'0.9em'}}
                              onClick={() => {
                                const d = selectedDate.toISOString().split('T')[0];
                                setAvailableTimes(prev => ({
                                  ...prev,
                                  [d]: prev[d].filter((x,i) => i!==idx)
                                }));
                              }}
                            >
                              x
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
                {/* Form per aggiungere nuovo orario */}
                <div className="new-date-form">
                  <input
                    type="time"
                    value={newTime}
                    onChange={e => setNewTime(e.target.value)}
                  />
                  <button
                    className="btn primary-btn"
                    onClick={() => {
                      const d = selectedDate.toISOString().split('T')[0];
                      if (!newTime) return;
                      setAvailableTimes(prev => ({
                        ...prev,
                        [d]: prev[d] ? [...prev[d], newTime] : [newTime]
                      }));
                      setNewTime("");
                    }}
                  >
                    Aggiungi Orario
                  </button>
                </div>
              </>
            )}
          </div>
        )}

        <button className="btn secondary-btn close-btn" onClick={onClose}>Chiudi</button>
      </div>
    </div>
  );
}

export default AdminModal;
